import { render } from "./SubMenu.vue?vue&type=template&id=40a0bc77"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__